var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7498 7L12.7498 4H11.2498L11.2498 7H12.7498ZM18.4869 8.49525L19.9869 5.99525L18.7007 5.2235L17.2007 7.7235L18.4869 8.49525ZM4.01291 5.99525L5.51291 8.49525L6.79915 7.7235L5.29915 5.2235L4.01291 5.99525ZM4.67905 14.0005C6.3301 16.1174 8.98806 17.5003 11.9986 17.5003C15.0094 17.5003 17.6676 16.1171 19.3186 13.9998C18.2826 12.6714 16.85 11.632 15.1826 11.042C15.3862 11.4859 15.4998 11.9797 15.4998 12.5C15.4998 14.433 13.9328 16 11.9998 16C10.0668 16 8.49979 14.433 8.49979 12.5C8.49979 11.9795 8.61342 11.4855 8.81722 11.0415C7.14886 11.6315 5.71549 12.6713 4.67905 14.0005ZM20.8661 13.5754C18.9713 10.8143 15.7038 9.00188 12.0049 9L11.9998 9H11.9995H11.9991C8.29747 9 5.02719 10.8132 3.13156 13.5763C2.95613 13.832 2.95615 14.1693 3.1316 14.4249C5.02733 17.1874 8.2973 19.0003 11.9986 19.0003C15.7002 19.0003 18.9705 17.187 20.8661 14.424C21.0415 14.1683 21.0415 13.831 20.8661 13.5754Z",
    fill: "#66727F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.2facb2c0ca31073895b3be814a7a36a0.svg";
export { ForwardRef as ReactComponent };